export function getYandexSpravAwardsLink(): string {
    return 'https://yandex.ru/support/business-priority/ru/manage/stiker';
}
